export const BASE_URL = process.env.REACT_APP_BASE_URL
export const API_URL = `${BASE_URL}/api/`
export const LOGIN_URL = `${BASE_URL}/login`
